import { TEXT } from '../../shared/languages';

export const InlineLoadingIndicator = ({
  label = TEXT.messages.searchingProperties,
  overlay = false,
}) => {
  const content = (
    <>
      <span className="inline-loading-dot" />
      <span>{label}</span>
    </>
  );

  if (overlay) {
    return (
      <div className="inline-loading-overlay" role="status" aria-live="polite" aria-busy="true">
        <div className="inline-loading">{content}</div>
      </div>
    );
  }

  return (
    <div className="inline-loading" role="status" aria-live="polite">
      {content}
    </div>
  );
};
